import React from 'react';
import { Helmet } from 'react-helmet-async';

// Definierar vilka props komponenten kan ta emot
interface MetaTagsProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  url?: string;
  type?: string; // t.ex. 'website', 'article', 'product'
  schema?: Record<string, any>; // För JSON-LD schema
  noIndex?: boolean; // Ny prop för noindex
}

// Grundläggande konfiguration för webbplatsen
const SITE_NAME = 'Pundeez';
const SITE_URL = 'https://pundeez.com';
const DEFAULT_IMAGE_URL = `${SITE_URL}/images/og-default.jpg`; // Skapa en defaultbild!
const DEFAULT_DESCRIPTION =
  'Premium underwear with empowering affirmations. Comfortable, sustainable, and designed to boost your confidence every day.';

const MetaTags: React.FC<MetaTagsProps> = ({
  title,
  description = DEFAULT_DESCRIPTION,
  imageUrl = DEFAULT_IMAGE_URL,
  url = SITE_URL,
  type = 'website',
  schema,
  noIndex = false, // Standard är att indexera
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonicalUrl = url.startsWith('/') ? `${SITE_URL}${url}` : url; // Säkerställ fullständig URL

  // Standard JSON-LD schema för organisationen om inget specifikt schema ges
  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/images/logo.png`, // Uppdatera sökväg till din logo
  };

  const finalSchema = schema || defaultSchema;

  return (
    <Helmet>
      {/* Grundläggande Meta-taggar */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={canonicalUrl} />
      )}
      {/* Open Graph Meta-taggar (för Facebook, LinkedIn, etc.) */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      {/* Twitter Card Meta-taggar */}
      <meta name="twitter:card" content="summary_large_image" />{' '}
      {/* Använd summary_large_image för bilder */}
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {/* <meta name="twitter:site" content="@dittTwitterHandle" />  */}
      {/* <meta name="twitter:creator" content="@dittTwitterHandle" /> */}
      {/* JSON-LD Strukturerad Data (Schema.org) */}
      <script type="application/ld+json">{JSON.stringify(finalSchema)}</script>
    </Helmet>
  );
};

export default MetaTags;
